module.exports = require("./../../_gen/openfl/net/URLRequestHeader");